import type { Ref } from "vue";
import { computed, ref } from "vue";

import { useApplicationStore } from "@/store/store/applicationVMStore";

export default function useApplicationData() {
  const applicationStore = useApplicationStore();

  const applicationStatus = computed<number>(
    () => applicationStore.application?.detailViewModel?.statusId || 0
  );

  const lenderId = computed<number>(
    () => applicationStore.viewModel?.lenderId || 0
  );

  const productTypeId = computed<number>(
    () => applicationStore.viewModel?.productTypeId || 0
  );

  const programTypeId = computed<number>(
    () => applicationStore.viewModel?.programTypeId || 0
  );

  return {
    applicationStatus,
    lenderId,
    productTypeId,
    programTypeId,
  };
}
